import {StrictMode, Suspense} from 'react';
import {render} from 'react-dom';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import VConsole from 'vconsole';
import {spyStart} from '@/utils/spy';
import '@/styles';
import routes from '../routes';

function createRoot() {
    const root = document.createElement('div');
    root.setAttribute('id', 'root');
    return root;
}
spyStart();

// 为qa测试环境开启调试
const hostname = window.location.hostname;
const port = window.location.port;

if (
    /^campaign-[a-zA-Z0-9]+\.now\.baidu\.com$/.test(hostname)
    || (hostname.includes('.baidu.com') && port === '8102')
) {
    new VConsole();
}

const main = () => render(
    <StrictMode>
        <BrowserRouter>
            <Suspense fallback={null}>
                <Routes>
                    {routes.map(({path, Component}) => (
                        <Route
                            key={path}
                            path={path}
                            element={<Component />}
                        />
                    ))}
                </Routes>
            </Suspense>
        </BrowserRouter>
    </StrictMode>,
    document.body.appendChild(createRoot())
);

main();
